import { render, staticRenderFns } from "./ComputacionNavar.vue?vue&type=template&id=6cacca1a&scoped=true"
import script from "./ComputacionNavar.vue?vue&type=script&lang=js"
export * from "./ComputacionNavar.vue?vue&type=script&lang=js"
import style0 from "./ComputacionNavar.vue?vue&type=style&index=0&id=6cacca1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cacca1a",
  null
  
)

export default component.exports